if (typeof URL !== "undefined" && typeof (URL as { parse?: unknown }).parse !== "function") {
  Object.defineProperty(URL, "parse", {
    value(url: string, base?: string): URL | null {
      try {
        return new URL(url, base);
      } catch {
        return null;
      }
    },
    writable: true,
    configurable: true,
  });
}
